import type { TranslationKey } from "../locales";
import type { Enums } from "../types";

export function getProjectInvoiceStateString(state: Enums<"outgoingInvoiceState">): TranslationKey {
	switch (state) {
		case "overdue":
			return "invoices.overdue";
		case "paid":
			return "invoices.paid";
		case "pending":
			return "invoices.pending";
	}
}
